import { Card, CardHeader, CardTitle, CardBody } from '@vnetwork/ui/primitives';
import styles from './Affiliate.module.css';

// Static policy text, effective 01/07/2026. Deliberately kept in Vietnamese —
// the surrounding console chrome is English, but the commission terms are a
// legal document supplied verbatim by the programme owner and must not be
// paraphrased or translated in the UI. The one deliberate departure from the
// source text is the spelling of "affiliate", which arrived misspelt.
export function AffiliatePolicy() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Chính sách Affiliate</CardTitle>
      </CardHeader>
      <CardBody>
        <div className={styles.policy}>
          <p>
            Áp dụng cho người dùng đăng ký sử dụng VCLOUD, VNCDN hoặc VNIS qua link affiliate hoặc
            nhập mã giới thiệu.
          </p>

          <ol className={styles.policyList}>
            <li>
              <strong>Hoa hồng kích hoạt VNIS</strong> (bao gồm cả WAF Free, áp dụng đến
              31/12/2026): 20.000đ/account cho số lượng 1–49 account, 30.000đ cho số lượng từ
              50–99, 40.000đ từ 100 account trở lên.
              <p className={styles.policyNote}>
                Ghi chú: Mức hoa hồng kích hoạt được tính theo bậc thang.
              </p>
            </li>
            <li>
              <strong>Hoa hồng trên đơn hàng</strong>: đợt thanh toán đầu tiên áp dụng mức 10% với
              VNIS, 15% với VNCDN và VCLOUD; các đợt thanh toán kế tiếp áp dụng mức 5%.
            </li>
          </ol>

          <p>
            Thanh toán hoa hồng: Chi trả hàng tháng, số tiền thực nhận đã khấu trừ 10% thuế TNCN.
          </p>
          <p>
            Chính sách này có hiệu lực từ 01/07/2026 cho tới khi có thông báo mới.
          </p>
        </div>
      </CardBody>
    </Card>
  );
}
